export const cilCheckAlt = ["24 24","<path d='M9.392 17.919l-6.53-6.122 1.026-1.094 5.47 5.128 10.736-10.736 1.061 1.061-11.764 11.764z'></path>"]